import { get, post, COUNTRY } from "./api_helper";

// GET /api/billing/account?country= → { activeUnitsAvailable, activeUnitsTotal, currencyCode, ... }
export const getBillingAccount = (country = COUNTRY) =>
  get(`billing/account?country=${country}`);

// GET /api/billing/account/batches?country=&status=ACTIVE → Page<SmsUnitBatch>
export const getBillingBatches = (country = COUNTRY) =>
  get(`billing/account/batches?country=${country}&status=ACTIVE`);

// GET /api/billing/account/unit-history?country= → { content[], summary }.
// summary.lifetimeConsumed = all-time units used (legacy `total_used_units`).
// We only read `summary` (lifetimeConsumed/Granted), never the ledger rows here,
// so size=1 keeps the payload tiny — summary is computed over the whole account
// regardless of page size. (size=0 errors: PageRequest requires >=1.)
export const getUnitHistory = (country = COUNTRY) =>
  get(`billing/account/unit-history?country=${country}&size=1`);

// POST /api/billing/top-up — cheque / bank-transfer flow (operator marks paid).
export const createTopUp = ({ amountMinor, country = COUNTRY }) =>
  post("billing/top-up", { countryIso2: country, amountMinor, provider: "BANK_TRANSFER" });
